import { format, parseISO } from "date-fns";
import { pitchLabel } from "@/lib/pitchLabel";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { SubscriptionFees } from "@/pages/admin/SubscriptionFees";
import { FinesLog } from "@/components/finance/FinesLog";

export function PaymentsTab({ paymentsRange, setPaymentsRange, loadPayments, paymentsBusy, payments, hideFees = false }) {
  return (
    <div className="space-y-4">
      {!hideFees && <SubscriptionFees />}
      <FinesLog compact />
      <div className="card-tactical rounded-md p-5">
        <div className="flex flex-wrap items-end gap-3 justify-between">
          <div>
            <div className="font-display font-bold text-2xl tracking-tight">Referee payments due</div>
            <p className="text-sm opacity-60 mt-1">Expected fees for confirmed league &amp; cup matches. Pulled from each league's payment grid.</p>
          </div>
          <div className="flex items-end gap-3 flex-wrap">
            <div>
              <Label className="text-xs uppercase tracking-widest opacity-70">From</Label>
              <Input type="date" value={paymentsRange.start} onChange={e=>setPaymentsRange({...paymentsRange, start: e.target.value})} data-testid="payments-start" className="mt-1.5" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest opacity-70">To</Label>
              <Input type="date" value={paymentsRange.end} onChange={e=>setPaymentsRange({...paymentsRange, end: e.target.value})} data-testid="payments-end" className="mt-1.5" />
            </div>
            <button onClick={loadPayments} disabled={paymentsBusy} data-testid="payments-run" className="btn-volt px-5 py-2.5 rounded-md">
              {paymentsBusy ? "Running…" : "Run report"}
            </button>
          </div>
        </div>
      </div>

      {payments && (
        <div className="card-tactical rounded-md overflow-hidden overflow-x-auto">
          {payments.summary.length === 0 ? (
            <div className="p-8 text-sm opacity-60 text-center">No refereed league/cup matches in this range.</div>
          ) : (
            <table className="w-full text-sm" data-testid="payments-table">
              <thead className="bg-muted text-[10px] tracking-widest uppercase opacity-60">
                <tr>
                  <th className="text-left px-4 py-3">Referee</th>
                  <th className="text-left px-4 py-3">Games</th>
                  <th className="text-left px-4 py-3">Total due</th>
                  <th className="text-left px-4 py-3">Breakdown</th>
                </tr>
              </thead>
              <tbody>
                {payments.summary.map(s => (
                  <tr key={s.referee_id} className="border-t border-border align-top">
                    <td className="px-4 py-3 font-medium">{s.referee_name || "—"}</td>
                    <td className="px-4 py-3">{s.games}</td>
                    <td className="px-4 py-3 font-display font-black text-[#83B68B]" data-testid={`payments-total-${s.referee_id}`}>£{s.total.toFixed(2)}</td>
                    <td className="px-4 py-3 text-xs opacity-80">
                      <div className="space-y-0.5">
                        {s.bookings.map(b => (
                          <div key={b.id}>
                            {format(parseISO(b.booking_date), "d MMM")} · {pitchLabel(b)} · {b.team_name || "—"} vs {b.opponent || "TBC"} — {b.expected_referee_fee != null ? `£${Number(b.expected_referee_fee).toFixed(2)}` : "no rate set"}
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t border-border bg-muted/50">
                  <td className="px-4 py-3 font-display font-bold uppercase text-xs tracking-widest">Total</td>
                  <td className="px-4 py-3">{payments.summary.reduce((n,s)=>n+s.games,0)}</td>
                  <td className="px-4 py-3 font-display font-black text-[#83B68B]" data-testid="payments-grand-total">£{payments.summary.reduce((n,s)=>n+s.total,0).toFixed(2)}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
